import chartGraphic from '@assets/img/png/chart-graphic.png'
import { LogService, MySquid, onConfigChange } from '@hub/shared'
import { SqButton } from '@squidit/react-css'
import onModalCreatorsInsightsObservable from '@src/observables/on-modal-creators-insights.observable'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SubscriptionLike } from 'rxjs'
import './banner-creators-insights.component.scoped.scss'

interface CreatorsInsightsBannerProps {
  className?: string
}

const CreatorsInsightsBanner = ({ className }: CreatorsInsightsBannerProps) => {
  const logService = useMemo(() => new LogService(), [])
  const { t } = useTranslation('bannerCreatorsInsights')
  const [configs, setConfig] = useState<MySquid | null>(null)
  logService.init('Initialize BannerCreatorsInsights component')

  useEffect(() => {
    const onConfigChangeObservable: SubscriptionLike = onConfigChange.subscribe((newConfig: MySquid | any) => {
      setConfig(newConfig)
    })

    return () => {
      onConfigChangeObservable?.unsubscribe()
    }
  }, [])

  const handleButtonClick = useCallback(async () => {
    onModalCreatorsInsightsObservable.next(true)
  }, [])

  if (configs?._id) {
    return null
  }

  return (
    <div className={`creators-insights-banner ${className}`}>
      <div className="content">
        <h1>Creators Insights</h1>
        <p>{t('explore_metrics')}</p>
        <SqButton color="var(--purple-40)" style={{ borderRadius: 8 }} size="sm" onClick={handleButtonClick} borderStyle="none">
          {t('access_button')}
        </SqButton>
      </div>
      <img src={chartGraphic} alt="chart graphic" />
    </div>
  )
}

export default CreatorsInsightsBanner
